import { createStore } from 'redux';

// A simple reducer for managing user and cart state
const initialState = {
  user: null,
  cart: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload };
    case 'ADD_TO_CART':
      return { ...state, cart: [...state.cart, action.payload] };
    default:
      return state;
  }
};

const store = createStore(reducer);

export default store;